import React, { createContext, useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { ClickAnalyticsPlugin } from "@microsoft/applicationinsights-clickanalytics-js";
import { useSelector, useDispatch } from "react-redux";
import { ErrorBoundary } from "react-error-boundary";
import PropTypes from "prop-types";
import { getUserLogged } from '../Store/Ducks/duckAuth.js';
import {ErrorPage} from "./../Pages/ErrorPage.jsx";
//import { actionToLog } from "../store/ducks/duckAudit";

//Contexto para disponibilizar appInsights en toda la aplicación
export const AppInsightsContext = createContext(null);
export const reactPlugin = new ReactPlugin();
export const clickPlugin = new ClickAnalyticsPlugin();

const AppInsightsProvider = (props) => {
  const { children } = props;
  const email = useSelector((store) => store.authentication.authenticatedUser.email);

  useEffect(() => {
    if (email === "") {
      dispatch(getUserLogged());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);

  const dispatch = useDispatch();
  const location = useLocation();

  if (email !== "") {
    localStorage.setItem("Email", email);
  }

  const appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY,
      enableDebug: process.env.NODE_ENV && process.env.NODE_ENV !== "production",
      disableTelemetry: process.env.NODE_ENV && process.env.NODE_ENV !== "production",
    },
  });

  appInsights.loadAppInsights();
  // appInsights.setAuthenticatedUserContext(email);

  const myErrorHandler = (error, info) => {
    let componentStack = info?.componentStack;
    let message = error?.message;

   // dispatch(actionToLog(location.pathname, "ERROR_BROWSER", message, componentStack));
    reactPlugin.trackException({ exception: error, properties: { info } });
  };

  return (
    <AppInsightsContext.Provider value={appInsights}>
      <ErrorBoundary
        FallbackComponent={(props) => <ErrorPage {...props} />}
        onError={myErrorHandler}
      >
        {children}
      </ErrorBoundary>
    </AppInsightsContext.Provider>
  );
};

//Hook para poder utilizar la instancia
/**
 * @returns {ApplicationInsights} applicationInsights Instance
 */
export const useAppInsights = () => useContext(AppInsightsContext);

AppInsightsProvider.propTypes = {
  children: PropTypes.node,
};

export default AppInsightsProvider;
